import React, { useEffect } from "react";
import "./FamilyConsults.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import familyImg from "../../Asset/Images/FamilyConsults.jpg";

const FamilyConsults = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 family support points
  const familyPoints = [
    "family.point1",
    "family.point2",
    "family.point3",
    "family.point4",
    "family.point5",
    "family.point6",
    "family.point7",
    "family.point8"
  ];

  return (
    <div className="family_page">
      {/* HERO SECTION */}
      <section className="family_hero">
        <div className="family_card_container">
          <div className="family_content" data-aos="fade-right">
            <span className="service_tag">{t('family.service_tag')}</span>
            <h1>
              {t('family.title_start')} <span>{t('family.title_end')}</span>
            </h1>
            <p>{t('family.hero_desc')}</p>
          </div>

          <div className="family_image" data-aos="fade-left">
            <img src={familyImg} alt={t('family.title_start') + " " + t('family.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="family_details">
        <h2 data-aos="fade-up">{t('family.details_title')}</h2>
        <div className="family_grid">
          {familyPoints.map((key, index) => (
            <div className="family_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="family_cta" data-aos="fade-up">
        <h2>{t('family.cta_title')}</h2>
        <p>{t('family.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default FamilyConsults;